import React, { useState, useEffect } from 'react';
import {
    Avatar, Button,
    Card, Col, Drawer,
    Row, Tabs, Table, Typography,
    Icon, Result, Statistic, Modal, Spin
} from 'antd';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavMenu from 'components/NavMenu';
import TextEvents from 'app/components/TextEvents';
import { useStyles, styles } from './CommunicationScreenStyles';
import CommunicationTableContainer from 'app/containers/CommunicationTableContainer';
import CommunicationQuizContainer from 'app/containers/CommunicationQuizContainer';
import ListSubheader from '@material-ui/core/ListSubheader';
import CommunicationForm from 'app/components/CommunicationForm';
import QuizForm from 'app/components/QuizForm';
import { fetchPendingCommunication, fetchFinishedCommunication, clearPendingCommunication, clearfinishedCommunication, clearAll, endCommunication, qualificationProccess } from 'app/actions/CommunicationActions';
import { useDispatch, useSelector } from 'react-redux';
import { communicationQuizClear } from 'app/actions/CommunicationQuizActions';
import { auth, employeeById, acceptDisclaimer, acceptDisclaimerIsLoading, disclaimerActiveIsLoading, disclaimerActive, getIsLoadingEndCommunication, getEndCommunication, getIsLoadingQualificationProcess } from 'app/reducers';
import Auth from '../../../config/auth'
import { clearAllStates, acceptDisclaimerBegin } from 'app/actions/LoginActions'
import { PURGE } from 'redux-persist';
import { endCommunicationBegin, endCommunicationSuccess } from 'app/actions/CommunicationActions';



import ApiService from 'app/services/ApiService';

const { Title, Paragraph, Text } = Typography;
const { TabPane } = Tabs;
const ButtonGroup = Button.Group;
const { Countdown } = Statistic;
const { confirm } = Modal;

export default function CommunicationScreen(props) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const userData = useSelector(auth);
    const employeeData = useSelector(employeeById);
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});

    const [activeKey, setTabBar] = useState('1');
    const [isVisible, setVisible] = useState(false);
    const tabs = { '1': 'Comunicaciones Pendientes', '2': 'Comunicaciones Finalizadas' }
    const [rowData, setRowData] = useState({});
    const [isFinished, setIsFinished] = useState(true);
    const [isChildrenVisible, setChildrenVisible] = useState(false);
    const [current, setCurrent] = useState(0);
    const [quizQuestionsData, setQuizQuestionsData] = useState();
    const [isResultVisible, setResultVisible] = useState(false);
    const [resultQuizData, setResultQuizData] = useState();
    const [answersQuizData, setAnswersQuizData] = useState([]);
    const [wasAnswered, setAnswered] = useState(true);
    const [istimeOver, setTimeOver] = useState(false);
    const [finish, setFinish] = useState(false);
    const userAcceptDisclaimer = useSelector(acceptDisclaimer);
    const isLoading = useSelector(acceptDisclaimerIsLoading);
    const isLoadingDisclaimerActive = useSelector(disclaimerActiveIsLoading);
    const disclaimerActiv = useSelector(disclaimerActive);
    const isLoadingEndCommunication = useSelector(getIsLoadingEndCommunication);
    const statusEndCommunication = useSelector(getEndCommunication);
    const isLoadingQualificationProcess = useSelector(getIsLoadingQualificationProcess);


    useEffect(() => {
        return () => {
            dispatch(clearPendingCommunication());
            dispatch(clearfinishedCommunication());
        }
    }, []);

    const onCancel = () => {
        setFinish(false);
        setVisible(false);
        setIsFinished(true);
        dispatch(communicationQuizClear());
        setCurrent(0);
        dispatch(clearPendingCommunication())
        dispatch(fetchPendingCommunication((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)))
        setFinish(false);
        setChildrenVisible(false);
    }

    const quizForm = () => {
        // setVisible(false)
        setChildrenVisible(true);
        dispatch(communicationQuizClear());
        setCurrent(0);

    }

    const onClickEndCommnication = async (data) => {
        dispatch(endCommunicationBegin());
        await ApiService.putQualification(data, []).then(
            res => {
                dispatch(endCommunicationSuccess());
                setResultVisible(true);
                setVisible(false);
            }
        )
    }

    const removeObjectProperties = function (obj, props) {

        for (var i = 0; i < props.length; i++) {
            if (obj.hasOwnProperty(props[i])) {
                delete obj[props[i]];
            }
        }

    };

    const quizDone = async (id, data, idTest) => {
        setVisible(false);
        setChildrenVisible(false);
        setFinish(false);
        if (typeof data === 'undefined') {
            dispatch(qualificationProccess(true))
            await ApiService.putQualification(id, []).then(
                res => {

                    setResultQuizData(res);
                    if (res.listAnswers != null) {
                        setAnswersQuizData(res.listAnswers)
                    } else {
                        setAnswersQuizData([])
                    }
                    dispatch(communicationQuizClear());
                    setCurrent(0);
                    dispatch(clearPendingCommunication())
                    dispatch(fetchPendingCommunication((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)))
                    setFinish(false);
                    dispatch(qualificationProccess(false))
                    setResultVisible(true);
                }
            );
        } else {
            data.forEach(i => {
                i.listAnswers = i.correctAnswer;
                i['idEmployee'] = (userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany);
                i['idTest'] = idTest;
                i['listAnswer'] = i.correctAnswer;
                removeObjectProperties(i, ['idQuestionType', 'isEvaluative', 'questionDescription', 'questionType', 'correctAnswer', 'deleted', 'questionTypeName'])
            });
            dispatch(qualificationProccess(true))
            await ApiService.putQualification(id, data).then(
                res => {
                    setResultQuizData(res);
                    if (res.listAnswers != null) {
                        setAnswersQuizData(res.listAnswers)
                    } else {
                        setAnswersQuizData([])
                    }
                    dispatch(communicationQuizClear());
                    setCurrent(0)
                    dispatch(clearPendingCommunication())
                    dispatch(fetchPendingCommunication((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)))
                    setFinish(false);
                    dispatch(qualificationProccess(false))
                    setResultVisible(true);
                }
            );
        }

    }
    const onFinish = () => {
        setTimeOver(true)
        typeof quizQuestionsData === 'undefined' ? quizDone(rowData.idCommunication, [], rowData.idTest) : quizDone(rowData.idCommunication, quizQuestionsData, rowData.idTest)
    }
    const next = () => {
        const curr = current + 1;
        setCurrent(curr);
    }

    const prev = () => {
        const curr = current - 1;
        setCurrent(curr);
    }

    const onChange = (current) => {
        setCurrent(current);
    }
    const onClose = () => {
        setFinish(false);
        confirm({
            title: '¿Deseas abandonar la prueba?',
            content: 'La prueba se enviará como incompleta.',
            okText: 'Continuar',
            cancelText: 'Salir',
            onCancel() {
                setChildrenVisible(false);
                quizDone(rowData.idCommunication, [], rowData.idTest);
                setCurrent(0);
                dispatch(communicationQuizClear());
                dispatch(clearPendingCommunication())
                dispatch(fetchPendingCommunication((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)))
            },
        });
    }

    const disclaimer = <Auth>
        {(params) => {
            return (

                <Modal
                    title="Aviso de Seguridad de la Información para proveedores"

                    visible={true}
                    onOk={() => dispatch(acceptDisclaimerBegin({ employeeId: userData.User.UserId.toString(), disclaimerId: disclaimerActiv.disclaimerId }))}
                    onCancel={() => params.logOut(() => {
                        dispatch(clearAll())
                        dispatch(clearAllStates())
                        dispatch({
                            type: PURGE,
                            key: 'root',
                            result: () => {
                                params.logOut(() => {
                                    props.history.push('/');
                                }, true);
                            }
                        });
                    })}
                    width={900}
                    okText='Estoy de acuerdo'
                    cancelText='No estoy de acuerdo'
                    closable={false}
                    maskClosable={false}
                    keyboard={false}
                    okButtonProps={{ disabled: isLoading || isLoadingDisclaimerActive }}
                    cancelButtonProps={{ disabled: isLoading || isLoadingDisclaimerActive }}
                >
                    <Spin spinning={isLoading || isLoadingDisclaimerActive} >
                        <p>
                            {disclaimerActiv.texto}
                        </p>

                        <p>Liga al Aviso de Privacidad: <a href={disclaimerActiv.urlTerminos}>{disclaimerActiv.urlTerminos}</a></p>
                    </Spin>
                </Modal>

            )
        }}
    </Auth>

    const proccessCommunicationEnd = <Result
        icon={
            statusEndCommunication ? <Icon type="check-circle" theme="twoTone" twoToneColor="#5CBF69" />
                : <Icon type="close-circle" theme="twoTone" twoToneColor="#ff3333" />
        }
        title={
            statusEndCommunication ? 'El proceso ha finalizado exitosamente!'
                : 'Ocurrió un error'
        }
        extra={<Button type="primary" onClick={() => {
            setResultVisible(false)
            dispatch(clearPendingCommunication())
            dispatch(clearfinishedCommunication())
            dispatch(fetchPendingCommunication((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)))
            dispatch(fetchFinishedCommunication((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)))
            setFinish(false);
        }}>Regresar</Button>}
    />

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} header='Gestión de comunicación' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <div color="inherit" disabled>
                            Gestion de comunicación
                        </div>
                        <TextEvents
                            text={tabs[activeKey]}
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Card className={classes.tabContainer}>
                    <Row>
                        <Col span={8} offset={6}>
                            <Title level={3}> {userData.User.FirstName + ' '
                                + userData.User.LastName + ' ' + userData.User.LastNameSecond + ' - ' + (userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)}</Title>
                            {userData.User.Position === null ? 'Empleado Externo' : userData.User.Position}

                        </Col>
                        <Col span={4} offset={4}>
                            <Avatar size={100} src={typeof employeeData === 'undefined' ? '' : employeeData.avatar} icon="user" />
                        </Col>
                    </Row>
                </Card>
                <div className="card-container" >
                    <Spin spinning={isLoadingEndCommunication || isLoadingQualificationProcess}>
                        <Tabs type="card" tabBarStyle={{ margin: 0 }} className={classes.tabContainer} onChange={tab => setTabBar(tab)}>
                            <TabPane tab="Pendientes" key="1" >
                                <Card >
                                    <CommunicationTableContainer
                                        classes={classes}
                                        setVisible={setVisible}
                                        setRow={setRowData}
                                        userData={userData.User}
                                        sorter={sorter}
                                        setSorter={setSorter}
                                        pagination={pagination}
                                        setPagination={setPagination}>
                                        {(params) => {
                                            return (
                                                <div>
                                                    <Table
                                                        columns={params.cols}
                                                        rowKey={item => String(item.idCommunication)}
                                                        dataSource={params.pendingCommunication}
                                                        loading={params.isLoading}
                                                        // scroll={{ x: 400 }}
                                                        onChange={params.handleTableChange}
                                                        pagination={pagination}
                                                        scroll={{ x: 'min-content', y: (height - 490) }}
                                                        size={"small"}
                                                    />
                                                </div>
                                            )
                                        }}
                                    </CommunicationTableContainer>
                                </Card>
                            </TabPane>
                            <TabPane tab="Finalizados" key="2">
                                <Card>
                                    <CommunicationTableContainer
                                        classes={classes}
                                        setVisible={setVisible}
                                        setRow={setRowData}
                                        userData={userData.User}
                                        sorter={sorter}
                                        setSorter={setSorter}
                                        pagination={pagination}
                                        setPagination={setPagination}>
                                        {(params) => {
                                            return (
                                                <div>
                                                    <ListSubheader>
                                                        <Table
                                                            columns={params.colsfinished}
                                                            rowKey={item => String(item.idCommunication)}
                                                            dataSource={params.finishedCommunication}
                                                            loading={params.isLoading}
                                                            // scroll={{ x: 600 }}
                                                            onChange={params.handleFinishedTableChange}
                                                            pagination={pagination}
                                                            scroll={{ x: 'min-content', y: (height - 395) }}
                                                        />
                                                    </ListSubheader>
                                                </div>
                                            )
                                        }}
                                    </CommunicationTableContainer>
                                </Card>
                            </TabPane>
                        </Tabs>
                    </Spin>
                </div>
                <Drawer
                    title="Evaluación del Procedimiento"
                    width={'100%'}
                    closable={false}
                    onClose={() => setVisible(false)}
                    visible={isVisible}
                    bodyStyle={{ height: '90%' }}
                    destroyOnClose={true}
                >

                    <CommunicationForm classes={classes} data={rowData} isFinished={isFinished} setIsFinished={setIsFinished} userData={userData.User} employeeData={employeeData} />
                    <Drawer
                        title={<div className={classes.timer}><Countdown title="Tiempo restante" value={Date.now() + 1000 * 60 * rowData.testDuration} format={"HH : mm : ss"} onFinish={onFinish} /></div>}
                        width={'100%'}
                        onClose={onClose}
                        visible={isChildrenVisible}
                        closable={true}
                        destroyOnClose={true}
                    >
                        <CommunicationQuizContainer data={rowData} isWorkCycle={false}>
                            {(params) => {
                                return (
                                    <div>
                                        <QuizForm classes={classes}
                                            current={current}
                                            next={next}
                                            onChange={onChange}
                                            prev={prev}
                                            quizData={params.communicationQuiz}
                                            setCurrent={setCurrent}
                                            setChildrenVisible={setChildrenVisible}
                                            setQuizQuestionsData={setQuizQuestionsData}
                                            quizQuestionsData={quizQuestionsData}
                                            setAnswered={setAnswered}
                                            wasAnswered={wasAnswered}
                                            setFinish={setFinish}
                                        />
                                        <div style={styles.bottomDrawer}>
                                            {Object.keys(params.communicationQuiz).length > 0 ? <ButtonGroup>
                                                {current > 0 && (
                                                    <Button type="dashed" style={{ marginLeft: 8, marginRight: 8 }} onClick={() => prev()}>
                                                        <Icon type="left" />
                                                        Anterior
                                                    </Button>
                                                )}
                                                {current < params.communicationQuiz.questions.length - 1 && (
                                                    <Button style={{ marginRight: 8 }} type="dashed" onClick={() => next()} disabled={wasAnswered} >
                                                        Siguiente
                                                        <Icon type="right" />
                                                    </Button>
                                                )}
                                            </ButtonGroup> : ''}
                                            {typeof quizQuestionsData !== 'undefined' ? <Button type="primary" style={{ marginRight: 8 }} disabled={finish === false} onClick={() => quizDone(rowData.idCommunication, quizQuestionsData, rowData.idTest)} >
                                                Finalizar
                                            </Button> : <div />}
                                        </div>
                                    </div>
                                )
                            }}
                        </CommunicationQuizContainer>
                    </Drawer>
                    <div style={styles.bottomDrawer}>
                        <Button type="danger" ghost style={{ marginRight: 8 }} onClick={() => onCancel()} >
                            Cancelar
                        </Button>
                        <Button onClick={
                            rowData.typeTraining !== 'Disciplina Operacional' && !rowData.evaluation ?
                                () => onClickEndCommnication(rowData.idCommunication)
                                :
                                () => quizForm()
                        } type="primary"
                            disabled={isFinished}
                        >
                            {rowData.typeTraining !== 'Disciplina Operacional' && !rowData.evaluation ? 'Finalizar' : 'Comenzar evaluación'}
                        </Button>
                    </div>

                </Drawer>
                <Drawer
                    title="Resultados"
                    width={'100%'}
                    closable={false}
                    onClose={() => setResultVisible(false)}
                    visible={isResultVisible}
                    destroyOnClose={true}
                >
                    {typeof resultQuizData !== 'undefined' ? <Result
                        icon={
                            rowData.typeTraining !== 'Disciplina Operacional' && !rowData.evaluation ? statusEndCommunication ? <Icon type="check-circle" theme="twoTone" twoToneColor="#5CBF69" /> : <Icon type="close-circle" theme="twoTone" twoToneColor="#ff3333" />
                                :
                                resultQuizData.isApproved ? <Icon type="check-circle" theme="twoTone" twoToneColor="#5CBF69" /> : <Icon type="close-circle" theme="twoTone" twoToneColor="#ff3333" />
                        }
                        title={
                            rowData.typeTraining !== 'Disciplina Operacional' && !rowData.evaluation ? statusEndCommunication ? 'El proceso ha finalizado exitosamente!' : 'Ocurrió un error'
                                :
                                resultQuizData.isApproved ? resultQuizData.approvalMessage : resultQuizData.approvalMessage/*'Evaluación finalizada exitosamente!' : 'Es necesario repetir el proceso.'*/}
                        subTitle={istimeOver === true ? 'Concluyó el tiempo de evaluación!' : ''}
                        extra={
                            <Button type="primary" onClick={() => {
                                setResultVisible(false)
                                dispatch(clearPendingCommunication())
                                dispatch(clearfinishedCommunication())
                                dispatch(fetchPendingCommunication((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)))
                                dispatch(fetchFinishedCommunication((userData.User.IdCompany == null ? userData.User.UserId : userData.User.IdCompany)))
                                setFinish(false);
                            }}>Regresar</Button>}
                    >
                        {
                            answersQuizData.length > 0 ?
                                <div className="desc">
                                    <Paragraph>
                                        <Text
                                            strong
                                            style={{
                                                fontSize: 16,
                                            }}
                                        >
                                            Respuestas Correctas
                                        </Text>
                                    </Paragraph>

                                    {
                                        answersQuizData.map((item, index) => (
                                            <Paragraph>
                                                <Icon style={{ color: 'green' }} type="check-circle" /> {item.questionDescription} &nbsp;
                                                <a>{item.answer} &gt;</a>
                                            </Paragraph>
                                        ))
                                    }
                                </div> : null
                        }

                    </Result> : rowData.typeTraining !== 'Disciplina Operacional' && !rowData.evaluation ? proccessCommunicationEnd : <div />}

                </Drawer>
                {
                    userData.User.IdCompany == null && !userAcceptDisclaimer ? disclaimer : null
                }
            </div>
        </div>
    )
}